import React, { useEffect, useState, useContext } from "react";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import Editor from "../../../Pages/Editor/Editor";
import "./HistoryPopup.scss";

function SampleItem({
  resumedata,
  index,
  randomTemplate,
  full,
  job_title,
  job_title1,
}) {
  const {
    json,
    setJson,
    jsonIndex,
    setJsonIndex,
    isJson,
    setIsJson,
    isSample,
    setIsSample,
  } = useContext(jsonEditorContext);

  //Json Handle
  let dateRange0 = {
    fromYear: 2018,
    fromMonth: "Mar",
    toYear: null,
    toMonth: null,
    isOnGoing: true,
    onGoingText: "Ongoing",
  };
  let dateRange1 = {
    fromYear: 2016,
    fromMonth: "Jan",
    toYear: 2018,
    toMonth: "Feb",
    isOnGoing: false,
    onGoingText: "Ongoing",
  };
  useEffect(() => {
    let data = JSON.parse(resumedata);
    if (data && data.profile && data.profile.data && data.profile.data[0]) {
      data.profile.data[0].jobTitle = job_title;
    }
    if (
      data &&
      data.experience &&
      data.experience.data &&
      data.experience.data[0]
    ) {
      data.experience.data[0].dateRange = dateRange1;
    }
    if (
      data &&
      data.experience &&
      data.experience.data &&
      data.experience.data[1]
    ) {
      data.experience.data[1].dateRange = dateRange1;
    }

    if (
      data &&
      data.education &&
      data.education.data &&
      data.education.data[0]
    ) {
      data.education.data[0].dateRange = dateRange0;
    }
    if (
      data &&
      data.education &&
      data.education.data &&
      data.education.data[1]
    ) {
      data.education.data[1].dateRange = dateRange1;
    }

    // data.layout =
    //   randomTemplate &&
    //   randomTemplate.settings &&
    //   randomTemplate.settings.layout;
    // data.sectionPosition =
    //   randomTemplate &&
    //   randomTemplate.settings &&
    //   randomTemplate.settings.sectionPosition;
    // data.customization =
    //   randomTemplate &&
    //   randomTemplate.settings &&
    //   randomTemplate.settings.customization;
    // data.editorSettings =
    //   randomTemplate &&
    //   randomTemplate.settings &&
    //   randomTemplate.settings.editorSettings;
    data.template_id = randomTemplate && randomTemplate;
    setJson(data);
    setJsonIndex(index);
    setIsJson(true);
    setIsSample(true);
  }, [resumedata, index]);

  return (
    <div className="sample_img_modal  w-100">
      <div
        className="preview_scale"
        style={
          full
            ? { transform: "scale(0.95)", transformOrigin: "0px 0px" }
            : { transform: "scale(0.25)", transformOrigin: "0px 0px" }
        }
      >
        <Editor index={index} sample={true} preview={true} />
      </div>
    </div>
  );
}

export default SampleItem;
